import React, { memo } from 'react';
import PropTypes from 'prop-types';
import MuiRadioGroup from '@material-ui/core/FormGroup';
export var RadioGroup = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement(MuiRadioGroup, Object.assign({
    "aria-label": props.label
  }, props));
});
export var propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
};
RadioGroup.propTypes = propTypes;
export default RadioGroup;